import { get } from "lodash";
import { EventData } from "./types";
import { processTrackName } from "../../utils";

export const processEventLabel = (data: EventData): string =>
  `${processTrackName(get(data, "payload.race.trackName"))} - R${get(
    data,
    "payload.race.raceNumber"
  )} - ${get(data, "payload.race.mtp")}`;
